<div class="create-page-container">
  <!-- Top row: Title and Steps -->
  <div class="top-row">
    <div class="title-area">
      <md-create-page-header [title]="'NAV.CREATE_NEW_HAULIER' | translate" icon="partner"></md-create-page-header>
    </div>
    <div class="steps-area">
      <mat-stepper #stepper labelPosition="end" class="header-stepper" (selectionChange)="onStepChange($event)">
        <mat-step [editable]="false" [completed]="stepperNavigation.stepsCompletion()[0]">
          <ng-template matStepLabel>{{ 'CREATE.STEP_CREATE' | translate }}</ng-template>
        </mat-step>
        <mat-step [editable]="false" [completed]="stepperNavigation.stepsCompletion()[1]">
          <ng-template matStepLabel>{{ 'CREATE.STEP_SYNC' | translate }}</ng-template>
        </mat-step>
        <mat-step [editable]="false">
          <ng-template matStepLabel>{{ 'CREATE.STEP_SET_PRICES' | translate }}</ng-template>
        </mat-step>
      </mat-stepper>
    </div>
  </div>

  <!-- Bottom row: Step Content -->
  <div class="content-row">
    <div class="step-content">
      @switch (stepper.selectedIndex) {
        <!-- Step 1 Content: HubSpot Creation -->
        @case (0) {
          <div class="step-content-inner">
            <div class="hs-form-frame" data-region="eu1" [attr.data-form-id]="hubSpotFormId" [attr.data-portal-id]="hubSpotPortalId"></div>
          </div>
        }

        <!-- Step 2 Content: System Integrations -->
        @case (1) {
          <div class="step-content-inner">
            <h4>{{ 'CREATE.INTEGRATION_STATUS_TITLE' | translate }}</h4>
            <p>{{ 'CREATE.INTEGRATION_STATUS_DESCRIPTION' | translate }}</p>
            <md-integration [systems]="getIntegrationsForStep(2)()"></md-integration>
          </div>
        }

        <!-- Step 3 Content: Pricing -->
        @case (2) {
          <div class="step-content-inner">
            @if (isLoading()) {
              <div class="loading-overlay">
                <mat-spinner></mat-spinner>
              </div>
            } @else {
              <h4>{{ 'CREATE.STEP_SET_PRICES' | translate }}</h4>

              @if (priceData()) {
                <md-add-price (dialogSubmit)="onPriceAdded($event)" [data]="priceData()"></md-add-price>
              }

              @if (createdItemPrices() && createdItemPrices().length > 0) {
                <md-price-list
                  [title]="'CREATE.CURRENT_PRICES' | translate"
                  [itemName]="localizedHaulierNameForDisplay()"
                  [prices]="createdItemPrices()"
                  (edit)="onEditPrice($event)"
                  (delete)="onDeletePrice($event)"
                >
                </md-price-list>
              }

              <div class="button-row">
                <button mat-flat-button color="primary" (click)="onDone()">
                  {{ 'COMMON.ACTIONS.FINISH' | translate }}
                </button>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
